import { useContext } from 'react';

import { LocalizationContext } from './LocalizationContext';
import { LocalizationContextInterface } from './types';

export const useLocalizationContext = (): LocalizationContextInterface => useContext(LocalizationContext);
